import { render } from "./OpsChangeInbox.vue?vue&type=template&id=5bf05ffa&scoped=true"
import script from "./OpsChangeInbox.vue?vue&type=script&lang=js"
export * from "./OpsChangeInbox.vue?vue&type=script&lang=js"

import "./OpsChangeInbox.vue?vue&type=style&index=0&id=5bf05ffa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf05ffa"]])

export default __exports__